import "./ModalResponse.scss";
import ReactModal from "react-modal";
import BorderCircle from "../BorderCircle/BorderCircle";
import Button from "../Button/Button";

ReactModal.setAppElement("#root");

const ModalResponse = ({ isOpen, title, message, onClose, closeForm }) => {
  const handleClose = () => {
    if (closeForm) closeForm(); // закрываем модалку с формой, если передана
    if (onClose) onClose();     // закрываем модалку-ответ
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Уведомление"
      className="modalResponse__window"
      overlayClassName="modalResponse__overlay"
    >
      <BorderCircle>
        <div className="modalResponse__content">
          <h3 className="modalResponse__title">{title}</h3>
          <p className="modalResponse__text">{message}</p>
          <div className="modalResponse__footer">
            <Button
              className="modalResponse__btn"
              content="Закрыть"
              handleClick={handleClose}
            />
          </div>
        </div>
      </BorderCircle>
    </ReactModal>
  );
};

export default ModalResponse;